import Web from '../Images/WebDevelop.avif';
import App from '../Images/APP.webp';
import UI from '../Images/UI.webp';
import Project from '../Images/Project.webp';
import Quality from '../Images/Quality.webp';
import Game from '../Images/Game.webp';


 const Sdata=[
    {
        imgsrc:App,
        title:'App Development'
    },
    {
        imgsrc: Web,
        title:'Web Development'
    },
    {
        imgsrc:UI,
        title:'UI/UX Designing'
    },
    {
        imgsrc: Quality,
        title:'Quality Assurance'
    },
    {
        imgsrc:Project,
        title:'Project Management'
    },
    {
        imgsrc:Game,
        title:'Game Development'
    },
    
]
export default Sdata;